// extracted by mini-css-extract-plugin
export default {"icon":"Profile_icon__bqlVl","img":"Profile_img__RhxSu","user":"Profile_user__QNghA"};